<script>
  // pages
  // import Machines from "./pages/Machines.svelte";
  // import About from "./pages/About.svelte";
  import Home from "./pages/Home.svelte";
  import MachineTemplate from "./pages/MachineTemplate.svelte";
  // router
  import { Router, Route, Link } from "svelte-routing";
  // components
  import Navbar from "./components/Navbar/Navbar.svelte";
  import Sidebar from "./components/Navbar/Sidebar.svelte";
  import Alert from "./components/Alert.svelte";

  import globalStore from "./stores/globalStore";
</script>

<Router>
  <!-- {#if window.location.pathname.indexOf('/m/') < 0}
    <Navbar />
    {#if $globalStore.sidebar}
      <Sidebar />
    {/if}

    {#if $globalStore.alert}
      <Alert />
    {/if}
  {/if} -->

  <Route path="/" component={Home} />
  <!-- <Route path="/about" component={About} />
  <Route path="/machines" component={Machines} /> -->
  <Route path="/m/:id" component={MachineTemplate} />
</Router>
